import React, { useEffect, useState } from "react";
import { db } from "../../../firebase";
import { useParams, useNavigate } from "react-router-dom";
import { message, Spin } from "antd";
import { doc, getDoc } from "firebase/firestore";
import "./UserWaitPage.css";
import Navbar from "../../../components/navigationbar/Navbar";
import Footer from "../../../components/Footer/Footer";

function UserWaitPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [requestData, setRequestData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRequestData = async () => {
      setLoading(true);
      try {
        const collectionName = id.startsWith("ADV")
          ? "advertisementRequests"
          : "CME-requests"; // Determine collection
        const docRef = doc(db, collectionName, id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          setRequestData(docSnap.data());
        } else {
          message.error("No request found for this ID.");
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        message.error("Failed to retrieve data.");
      } finally {
        setLoading(false);
      }
    };

    if (id) fetchRequestData();
  }, [id]);

  const handlePayment = () => {
    navigate("/Checkout", { state: { requestId: id } });
  };

  if (loading) {
    return (
      <div className="loading-container">
        <Spin size="large" />
      </div>
    );
  }

  if (!requestData) {
    return <div>No data available for this request.</div>;
  }

  return (
    <>
      <Navbar />
      <div className="user-wait-page">
        <div className="user-wait-card">
          <h2>Approval Status</h2>
          <div className="info-container">
            {id.startsWith("ADV") ? (
              <>
                <p>
                  <strong>Doctor Name:</strong>{" "}
                  {requestData.doctorName || "N/A"}
                </p>
                <p>
                  <strong>Email:</strong> {requestData.email || "N/A"}
                </p>
                <p>
                  <strong>Hospital Name:</strong>{" "}
                  {requestData.hospitalName || "N/A"}
                </p>
                <p>
                  <strong>Mobile:</strong> {requestData.mobile || "N/A"}
                </p>
                <p>
                  <strong>Status:</strong>{" "}
                  <span
                    className={`status ${
                      requestData.status === "Approved" ? "approved" : "pending"
                    }`}
                  >
                    {requestData.status}
                  </span>
                </p>
                <p>
                  <strong>Unique ID:</strong> {requestData.uniqueId || "N/A"}
                </p>

                <span
                  style={{
                    textAlign: "center",
                    margin: "20px auto",
                    padding: "10px 20px",
                    display: "block",
                    fontSize: "1rem",
                    fontWeight: "500",
                    color: "#333",
                    backgroundColor: "#f4f4f4",
                    borderRadius: "8px",
                    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
                  }}
                >
                  Your advertisement request for GPA Ichalkaranji has been
                  submitted and will be reviewed; our team will reach out to you
                  upon approval.
                </span>
              </>
            ) : (
              <>
                <p>
                  <strong>Hospital:</strong> {requestData.hospital || "N/A"}
                </p>
                <p>
                  <strong>Doctor's Names:</strong>
                </p>
                <ul>
                  {requestData.doctorNames?.length ? (
                    requestData.doctorNames.map((doctor, index) => (
                      <li key={index}>{doctor}</li>
                    ))
                  ) : (
                    <p>No doctors registered.</p>
                  )}
                </ul>
                <p>
                  <strong>Email:</strong> {requestData.email || "N/A"}
                </p>
                <p>
                  <strong>Phone:</strong> {requestData.phone || "N/A"}
                </p>
                <p>
                  <strong>CME Subjects:</strong>
                </p>
                <ul>
                  {requestData.cmeSubjects?.length ? (
                    requestData.cmeSubjects.map((subject, index) => (
                      <li key={index}>{subject}</li>
                    ))
                  ) : (
                    <p>No subjects registered.</p>
                  )}
                </ul>
                <p>
                  <strong>Status:</strong>{" "}
                  <span
                    className={`status ${
                      requestData.status === "Approved" ? "approved" : "pending"
                    }`}
                  >
                    {requestData.status}
                  </span>
                </p>
              </>
            )}
          </div>
          {requestData.status === "Pending" && (
            <p className="status-message">Proceed to the payment page soon.</p>
          )}
          {requestData.status === "Approved" && (
            <button className="payment-btn" onClick={handlePayment}>
              Make Payment
            </button>
          )}
        </div>
      </div>
      <Footer />
    </>
  );
}

export default UserWaitPage;
